import React, {useState} from 'react';
import {Box, Button} from "@mui/material";
import CustomSearch from "../common/CustomSearch";

type Props = {
    children: JSX.Element,
};

const SearchComponent: React.FC<Props> = ({children}) => {

    return (
        <Box sx={{
            height: "80px",
            maxWidth: "100%",
            padding: "20px",
            borderBottom: 1,
            borderColor: 'divider',
            display: "flex",
            alignItems: "center",
        }}>
            {children}
        </Box>
    );
};

export default SearchComponent;